<template>

  <div class="video grid grid__item_span-12 p0 m0">

    <!-- <video width="105%" height="auto" loop autoplay muted playsinline>
      <source :src="item.video_file['url']" type="video/mp4">
    </video> -->



    <video v-if="!mobileClass" width="105%" height="auto" autoplay muted loop playsinline :style="item.video_size">
      <source :src="item.video_file['url']" type="video/mp4">
    </video>
     <video v-if="mobileClass" width="105%" height="auto" autoplay muted loop playsinline :style="item.video_size_mobile">
      <source :src="item.video_file['url']" type="video/mp4">
    </video>

  </div>

</template> 

<script>

import animateScroll from '../../assets/js/projectAnimation.js'
var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'PageVideo',
  props: [
    'item'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      mobileClass: ''
    }
  },
  methods: {
    animateElements () {
      animateScroll.animate()
    },
    mobileDetect () {
      var browserSize = window.innerWidth || document.body.clientWidth
      var deviceMaxSize = 1024
      if (browserSize < deviceMaxSize) {
        this.mobileClass = 'deviceActive'
      }
    }
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      if (visible === true) {
        // console.log('YES')
        this.animateElements()
      } else {
        // console.log('no luck')
      }
    }
  },
  mounted () {
    this.mobileDetect()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .singleImage {
    height: auto;
  }
  .singleImage img{
    width: 100%;
    height: 100%;
  }

  .video_skin{
    background-position: center 0;
    background-repeat: no-repeat;
    background-size: cover;
    height:130vh;
    width: 100vw;
  }


</style>



// WEBPACK FOOTER //
// src/components/project/video.vue